// Canvas v2 keyboard shortcuts.

import { MODES } from '../../globalScope.js'

export function onCanvasKeydown(ev) {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const meta = ev.metaKey || ev.ctrlKey
  const k = ev.key

  if (meta && k.toLowerCase() === 'a') {
    ev.preventDefault()
    this.call('selectMany', Object.keys(v2.items))
    return
  }
  if (k === 'Escape') {
    if (v2.settingsOpen) { this.call('setCanvasSettings', false); return }
    this.call('clearSelection')
    return
  }
  if (meta && k.toLowerCase() === 'g') {
    ev.preventDefault()
    if (ev.shiftKey) {
      const ids = v2.selection.ids
      Object.entries(v2.groups || {})
        .filter(([, g]) => g.children.some((c) => ids.includes(c)))
        .forEach(([gid]) => this.call('ungroup', gid))
    } else {
      this.call('group')
    }
    return
  }
  if (meta && k === ',') {
    ev.preventDefault()
    this.call('toggleCanvasSettings')
    return
  }
  if (meta && k.toLowerCase() === 'd') {
    ev.preventDefault()
    this.call('duplicateSelection')
    return
  }
  if (k === 'Delete' || k === 'Backspace') {
    if (!v2.selection.ids.length) return
    ev.preventDefault()
    this.call('deleteSelection')
    return
  }
  if (meta && k.toLowerCase() === 'z') {
    ev.preventDefault()
    if (ev.shiftKey) this.call('redo')
    else this.call('undo')
    return
  }

  // Nudge selected items in place (no remount).
  const arrows = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }
  const d = arrows[k]
  if (d) {
    if (!v2.selection.ids.length) return
    ev.preventDefault()
    const step = (ev.shiftKey ? 10 : 1) / (v2.viewport.scale || 1)
    const items = this.getRoot?.()?.lookdown?.('CvItems')
    v2.selection.ids.forEach((id) => {
      const it = v2.items[id]; if (!it) return
      const nx = it.x + d[0] * step
      const ny = it.y + d[1] * step
      this.call('patchCanvasItem', id, { x: nx, y: ny })
      if (items) {
        for (const child of Object.values(items)) {
          if (child?.state?.key === id && child?.update) {
            child.update({ style: { left: nx + 'px', top: ny + 'px' } })
            break
          }
        }
      }
    })
    this.call('refreshCanvasChrome')
    this.call('pushHistory')
    this.call('persistCanvasLayout')
    return
  }

  if ((meta && k === '0') || k === 'Home') {
    ev.preventDefault()
    this.call('resetCanvasView')
    return
  }
  if (meta && k === '1') {
    ev.preventDefault()
    this.call('fitToSelection')
    return
  }
  if (meta && k === '/') {
    ev.preventDefault()
    this.call('toggleShortcutsOverlay')
    return
  }
  if (meta && k.toLowerCase() === 'l') {
    ev.preventDefault()
    this.call('autoLayout')
    return
  }

  if (k === 'v' || k === 'V') this.call('setCanvasV2Mode', MODES.DEFAULT)
  if (k === 'h' || k === 'H') this.call('setCanvasV2Mode', MODES.PAN)
  if (k === 'i' || k === 'I') this.call('setCanvasV2Mode', MODES.INSPECT)
  if (k === 'u' || k === 'U') this.call('setCanvasV2Mode', MODES.INTERACT)

  if (k === ' ' && !ev.repeat) {
    ev.preventDefault()
    if (v2.mode !== MODES.PAN) {
      this.call('setCanvasV2Mode', MODES.PAN)
      const scope = this.call('getCanvasScope')
      if (scope) scope._spaceModeFrom = 'space'
    }
  }
}

export function onCanvasKeyup(ev) {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  if (ev.key === ' ') {
    const scope = this.call('getCanvasScope')
    if (scope?._spaceModeFrom === 'space') {
      scope._spaceModeFrom = null
      this.call('setCanvasV2Mode', MODES.DEFAULT)
    }
  }
}
